import { useCallback } from "react";
import { useNavigation } from "../../../hooks/useNavigation";
import { PageRoutes } from "../../../constants/routes";

export const useForgotPasswordSendMail = () => {
  const { navigateToPage } = useNavigation();
  const handleForgotPasswordSendMail = useCallback(() => {
    navigateToPage(PageRoutes.FORGOT_PASSWORD, true);
  }, []);

  return { handleForgotPasswordSendMail };
};
